import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBJumbotron,  MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon, MDBBadge, MDBInput, MDBView, MDBDataTable} from "mdbreact";
import Axios from 'axios'
import { Layout, Menu, Breadcrumb, Icon, Select, Input, Button ,Card   } from 'antd';
import { StarOutlined, StarFilled, StarTwoTone, CaretDownOutlined, UserOutlined, RightCircleOutlined, SearchOutlined } from '@ant-design/icons';

import Highlighter from 'react-highlight-words';
//import Modalteachingschedule from './Modalteachingschedule';
//import Modalcolor from './Modalcolor';
import { Table,   Space } from 'antd';
import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';  
//import html2canvas from 'html2canvas';  

//import Table from '@material-ui/core/Table';  
import { CSVLink, CSVDownload } from "react-csv";
 import ReactExport from "react-export-excel";
import Modelupdatetecher from './Modelupdatetecher';
import { api, URL } from '../../api';


//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

//import Button from '@material-ui/core/Button';  
    
////import React, { useRef } from "react"

export default class Teacher extends Component {
    
    constructor(props) {
        super(props);
        this.state = {

          thschedule:[],
          modal: false,
          term:'',
          type:'1',
         
      
          dd3:'',
          teacher:'',
         
          search: '',

          Showteather:[],
          student: [],
          buttnoshow: false,
          pagination: {
            current: 1,
            pageSize: 20,
          },

        };
       
        this.onFocus = this.onFocus.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.refreshPage = this.refreshPage.bind(this);
      
        
      }


    updateSearchDepartment(value) {
        // console.log(event.target.value)
        // const term = event.target.value;
        const term = value;
        this.setState({ term });
 
           setTimeout(() => {
             this.getthschedule()
           }, 500);
      }


      getthschedule() {
        setTimeout(() => {
           //ภายใน
            Axios.get('https://mua.kpru.ac.th/FrontEnd_Tabian/load/getthschedule/'+this.state.term)
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ thschedule: res.data})
           }) 
         }, 0);
      }


      getsearch() {


        Axios.get(`https://arit.kpru.ac.th/ap/survey/api.php?nu=reports&code=20210719&PostionType=%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2&id=${this.state.major}&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR37lj-5gXs9k55vAErqiHHH-Nyr5WKEzJIY_M_O_fsHzazOYbxbyZwusg4`,
           //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
             {headers: {
                // Authorization: 'Bearer ' + localStorage.getItem('myData')
             }
             })
           //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
             .then(res => {
            // console.log(res.data[0].id)
                // console.log(res.data)
             
                //   console.log(ppp)
              //  const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
                const student = res.data;
                 this.setState({ student });
                 this.setState({ buttnoshow : true});
                
             })
       }

      getteachingschedule() {


       Axios.get(`https://arit.kpru.ac.th/ap/survey/api.php?nu=reports&code=20210719&PostionType=%E0%B8%99%E0%B8%B1%E0%B8%81%E0%B8%A8%E0%B8%B6%E0%B8%81%E0%B8%A9%E0%B8%B2&id=&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D&fbclid=IwAR37lj-5gXs9k55vAErqiHHH-Nyr5WKEzJIY_M_O_fsHzazOYbxbyZwusg4`,
          //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
            {headers: {
               // Authorization: 'Bearer ' + localStorage.getItem('myData')
            }
            })
          //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
            .then(res => {
                console.log(res.data[0].id)
               // console.log(res.data)
            
               //   console.log(ppp)
             //  const student = res.data.filter( ({ citizen_id }) => citizen_id.substring(0, 7) === this.state.major );
               const student = res.data;
                this.setState({ student });
                this.setState({ major:'' });
            })
      }

      sentpdf() {
        setTimeout(() => {
          window.open('https://e-student.kpru.ac.th/vaccinekpru/vaccinepdf/report/tess.php?stu='+this.state.major+'', '_blank');
           // window.location.href ='http://localhost/tesspdf/TCPDF-main/tess.php?term='+this.state.term+'&idemp='+this.state.idemp 
         }, 0);
      }

    

   
     resetdata= e =>{
      console.log(e.target.value);
        // const idemp = value;
         this.setState({ major:'' });

    }


         onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
          }

          time() {
            const d = new Date();
            d.setMinutes(17);
            document.getElementById("demo").innerHTML = d;
          }

          refreshPage() {
            window.location.reload(false);
          }


          componentDidMount(){
           

              if (localStorage.getItem('name') == null) {
               
                  window.location.href = 'https://e-student.kpru.ac.th/creditbank'
               
            } else {
        
            }
            api.get('index/getteacheruniv/'+localStorage.getItem('Univ_ID'),
          //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
            //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                    {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                    }
                    })
                    //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                    .then(res => {
                    // console.log(res.data[0].id)
                    //  console.log(res.data)
                    //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                    //  console.log(Course)
                      const Showteather = res.data;
                        this.setState({ Showteather });
                    })          
          }


          getColumnSearchProps = dataIndex => ({
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters , filters}) => (
              <div style={{ padding: 8 }}>
                <Input
                  ref={node => {
                    this.searchInput = node;
                  }}
                  placeholder={`ค้นหา`}
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                  style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                  type="primary"
                  onClick={() => this.handleSearch(selectedKeys, confirm)}
                  icon=""
                  size="small"
                  style={{ width: 90, marginRight: 8 }}
                >
                  ค้นหา
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                  ยกเลิก
                </Button>
              </div>
            ),
            filterIcon: filtered => (
              <SearchOutlined />
        
            ),
        
            onFilter: (value, record) =>
              record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => this.searchInput.select());
              }
            },
        
            
            render: text => (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={[this.state.searchText]}
                autoEscape
                textToHighlight={text.toString()}
              />
            ),
          });
        
          handleSearch = (selectedKeys, confirm) => {
            confirm();
            this.setState({ searchText: selectedKeys[0] });
          };
        
          handleReset = clearFilters => {
            clearFilters();
            this.setState({ searchText: '' });
          };
                
          clearFilters = () => {
            this.setState({ filteredInfo: null });
          };
        
        
          clearAll = () => {
            this.setState({
              filteredInfo: null,
              sortedInfo: null,
            });
          };



    render() {

      //  console.log(this.state.Showteather)

      let { sortedInfo, filteredInfo } = this.state;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};
      const {  pagination } = this.state;
     
      const columns = [

        {
            title: 'คำนำหน้า',
            dataIndex: 'Teacher_PNAME',
            key: 'Teacher_PNAME',
         //   responsive: ["sm"],
            ...this.getColumnSearchProps('Teacher_PNAME'),
            render: text => <a>{text}</a>,
        },
        {
          title: 'ชื่อ',
          dataIndex: 'Teacher_NAME',
          key: 'Teacher_NAME',
          ...this.getColumnSearchProps('Teacher_NAME'),
       
          render: (text, record) => (<><p>{record.Teacher_PNAME}{record.Teacher_NAME}</p>
           </> )
        },
        {
            title: 'นามสกุล',
            dataIndex: 'Teacher_LASTNAME',
            key: 'Teacher_LASTNAME',
            ...this.getColumnSearchProps('Teacher_LASTNAME'),
            render: (text, record) => (<><p>{record.Teacher_LASTNAME}</p>
   
        </> )
           // render: text => <a>{text}</a>,
        },
        {
          title: 'มหาวิทยาลัย',
          dataIndex: 'Univ_NAME',
          key: 'Univ_NAME',
          ...this.getColumnSearchProps('Univ_NAME'),
          render: (text, record) => (<><p>{record.Univ_NAME}</p> 
      </> )
         // render: text => <a>{text}</a>,
      },
        
      ];

        const { Option } = Select;
    //  const studentsa =  this.state.student.map(showteachingschedule => { 
    //   [  { firstname: showteachingschedule.citizen_id, lastname: showteachingschedule.citizen_id, email: showteachingschedule.citizen_id } ] 
    //   }  )    
    
               //ชุดตาราง
               const data = {
                columns: [
                  {
                    label: 'ลำดับ',
                    field: 'list',
                    sort: 'list',
                    width: 150
                  },
                  {
                    label: 'ชื่อ',
                    field: 'Teacher_NAME',
                    sort: 'Teacher_NAME',
                    width: 270
                  },
                  {
                    label: 'นามสกุล',
                    field: 'Teacher_LASTNAME',
                    sort: 'Teacher_LASTNAME',
                    width: 200
                  },
                  {
                    label: 'มหาวิทยาลัย',
                    field: 'Univ_NAME',
                    sort: 'Univ_NAME',
                    width: 100
                  }

                ],
      
                rows: [...this.state.Showteather.map((data, i) => (
                  {
                     list: <>{i+1}</>,
                     Teacher_NAME: <>{data.Teacher_PNAME}{data.Teacher_NAME}</>,
                     Teacher_LASTNAME: <>{data.Teacher_LASTNAME}</>,
                     Univ_NAME: <>{data.Univ_NAME}</>,
                  

                     random: <h5 searchvalue={data.Curriculumopen_TEAM} >tourist <span className="badge badge-danger">narrow</span></h5>,
       
                  }
                 ))] 
            
            };
      
            const persons = <MDBDataTable
           // searching ={true}
            searchLabel="ค้นหา อาจารย์"
            striped
            bordered
            small 
            entries={20}
           // entriesOptions={["10", "20"]}
            order={["age", "desc"]}
            data={data}
            entriesLabel="จำนวนที่แสดง "
            infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
            paginationLabel={["ย้อนกลับ", "ถัดไป"]}
            responsive 
            sortRows={['random']}
      />
      //ชุดตาราง

        return (
            <MDBContainer fluid>
                {/* <MDBAlert color="primary" >
                <h4><MDBIcon icon="address-book" className="indigo-text pr-3" /> ตารางเรียน </h4>
                </MDBAlert>
                <br/> */}
    
{/* <CSVLink data={data}>Download EXCEL</CSVLink> */}
       <Card type="inner" style={{ marginTop: 16 }}  title={<h4><MDBIcon icon="list-alt" /> ข้อมูลผู้สอน</h4> } extra={<a href="#"><p>คุณ{localStorage.getItem('name')}</p></a>} >
        <MDBJumbotron className="p-4" >
            <p className="text-right"><Modelupdatetecher/>  </p> 
            <h2 className="display-5 deep-purple-text text-center">ข้อมูลผู้สอน </h2>
                <MDBRow>
                          <MDBCol sm="12">

                          {/* <p>พบทั้งหมด {this.state.Showteather.length} รายการ</p>
                          <Table  columns={columns} dataSource={this.state.Showteather}  size="small"  />      */}
                          {persons} 
                          </MDBCol>
                         
                
                </MDBRow>
        </MDBJumbotron>
        </Card>

        {/* <Card title="Card title">
         <Card type="inner" title="Inner Card title" extra={<a href="#">More</a>}>
          Inner Card content
         </Card>
         <Card
          style={{ marginTop: 16 }}
          type="inner"
          title="Inner Card title"
          extra={<a href="#">More</a>}
         >
          Inner Card content
         </Card>
         </Card> */}

            </MDBContainer>
        )
    }
}
